import { z } from "zod";

export type QcConversationDesign = z.infer<typeof QcConversationDesignSchema>;
export const QcConversationDesignSchema = z.object({
  conversation_id: z.string().nullable(),
  title_bar_txt_color: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
  title_bar_bg_color: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
});
